'use client'

import React, { Dispatch, FC, ReactNode, SetStateAction, createContext, useContext, useState, useEffect } from 'react'
import { SeedSkin, premadeSkins } from '../../prisma/seed-data/skins'
import { Skin } from '@prisma/client'

// ————— types —————

type SkinContextState = {
  skin: Skin | SeedSkin
  setSkin: Dispatch<SetStateAction<Skin | SeedSkin>>
}

// ————— context —————
const defaultState: SkinContextState = {
  skin: premadeSkins[0],
  setSkin: () => {}
}
const SkinContext = createContext<SkinContextState>(defaultState)

// ————— provider —————

interface SkinProviderProps {
  children: ReactNode
  initialSkin?: Skin | SeedSkin
}

export const SkinProvider: FC<SkinProviderProps> = ({ children, initialSkin }) => {
  // ————— local state —————
  const [skin, setSkin] = useState<Skin | SeedSkin>(initialSkin || premadeSkins[0])

  // Update skin if initialSkin changes (e.g. when navigating between slaps)
  useEffect(() => {
    if (initialSkin) {
      setSkin(initialSkin)
    }
  }, [initialSkin])

  // ————— render —————

  return (
    <SkinContext.Provider
      value={{
        skin,
        setSkin
      }}
    >
      {children}
    </SkinContext.Provider>
  )
}

// ————— hooks —————
export const useSkin = () => useContext(SkinContext)
